import { FCC, H4 } from "@dgs/core";
import { useId } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

interface Props {
	stayCount: number;
	maxStays: number;
	error?: string | false;
}

const Error = styled.div`
	${({ theme }) => theme.forms.error};
`;

const InlineH4 = styled(H4)`
	display: inline;
`;

export const RegistrationHotelSectionTitle: FCC<Props> = ({ maxStays, stayCount, error, children }) => {
	const { t } = useTranslation();
	const titleId = useId();
	const errorId = useId();

	return (
		<section aria-labelledby={titleId} aria-invalid={!!error} aria-errormessage={error ? errorId : undefined}>
			<InlineH4 id={titleId}>{t("Hotel stays")}</InlineH4>{" "}
			{maxStays > 0 && (
				<>
					(
					{t("{{count}} of {{max}}", {
						count: stayCount,
						max: maxStays,
					})}
					)
				</>
			)}
			{error && <Error id={errorId}>{error}</Error>}
			{children}
		</section>
	);
};
